import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import './styles/styles.css';

// Shared components
import Navbar from './components/shared/Navbar';
import Footer from './components/shared/Footer';
import ScrollToTop from './components/shared/ScrollToTop';
import GlobalStyles from './GlobalStyles';

// Lazy load pages for code splitting
const Home = lazy(() => import('./pages/home/Home'));
const AboutUs = lazy(() => import('./pages/about-us/AboutUs'));
const Terms = lazy(() => import('./pages/legal/Terms'));
const PrivacyPolicy = lazy(() => import('./pages/legal/PrivacyPolicy'));
const Contact = lazy(() => import('./pages/contact/Contact'));
const Careers = lazy(() => import('./pages/careers/Careers'));
const Services = lazy(() => import('./pages/services/Services'));
const Employers = lazy(() => import('./pages/employers/Employers'));
const Employees = lazy(() => import('./pages/employees/Employees'));

// Loading component
const LoadingFallback = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '50vh',
    fontSize: '18px'
  }}>
    Loading...
  </div>
);

function App() {
  return (
    <>
      <GlobalStyles />
      <ScrollToTop />
      <Navbar />
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/employers" element={<Employers />} />
          <Route path="/employees" element={<Employees />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/terms-and-conditions" element={<Terms />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </Suspense>
      <Footer />
    </>
  );
}

export default App;
